const Tabs = {
  text: 'text',
  style: 'style',
  share: 'share',
}

export default Tabs
